var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "UI / Print"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_303_1703",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2062",
    width: 25,
    height: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_303_1703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "print"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.03125 17.5303H3.15625C2.77501 17.5303 2.40936 17.3788 2.13978 17.1093C1.8702 16.8397 1.71875 16.474 1.71875 16.0928V8.90527C1.71875 8.52403 1.8702 8.1584 2.13978 7.88881C2.40936 7.61923 2.77501 7.46777 3.15625 7.46777H21.8437C22.225 7.46777 22.5907 7.61923 22.8603 7.88881C23.1298 8.1584 23.2812 8.52403 23.2812 8.90527V16.0928C23.2812 16.474 23.1298 16.8397 22.8603 17.1093C22.5907 17.3788 22.225 17.5303 21.8437 17.5303H18.9687",
    stroke: "#97C4B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.59375 10.3428H6.03125",
    stroke: "#97C4B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.03125 13.2178H18.9687V23.2803H6.03125V13.2178Z",
    stroke: "#97C4B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.9687 7.46777H6.03125V3.15527C6.03125 2.77403 6.18271 2.40839 6.45228 2.1388C6.72186 1.86922 7.08751 1.71777 7.46875 1.71777H17.5312C17.9125 1.71777 18.2782 1.86922 18.5478 2.1388C18.8173 2.40839 18.9687 2.77403 18.9687 3.15527V7.46777Z",
    stroke: "#97C4B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.90625 16.0928H16.0937",
    stroke: "#97C4B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.90625 18.9678H13.9375",
    stroke: "#97C4B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};
export default SvgPrint;